var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Fragment } from "react";
import { Button, CheckBox, Column, DropDown, DropDownContent, DropDownTrigger, Pre, Row, RowLR, Spinner } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { Observer } from "vwebapp-framework";
import { store } from "Store";
import { runInAction } from "mobx";
let WriteOthersDropDown = class WriteOthersDropDown extends BaseComponentPlus({}, {}) {
    render() {
        const splitAt = 230;
        const sharedProps = { splitAt };
        return (React.createElement(DropDown, null,
            React.createElement(DropDownTrigger, null,
                React.createElement(Button, { ml: 5, text: "Others" })),
            React.createElement(DropDownContent, { style: { right: 0, width: 320, zIndex: 1 } },
                React.createElement(Column, null,
                    React.createElement(GoalsSection, Object.assign({}, sharedProps))))));
    }
};
WriteOthersDropDown = __decorate([
    Observer
], WriteOthersDropDown);
export { WriteOthersDropDown };
let GoalsSection = class GoalsSection extends BaseComponentPlus({}, {}) {
    render() {
        const { splitAt } = this.props;
        const targetWeekCompletion = store.main.write.targetWeekCompletion;
        const characters_showAttributes = store.main.write.characters_showAttributes;
        const characters_showDescription = store.main.write.characters_showDescription;
        const screenshotMode = store.main.write.screenshotMode;
        return (React.createElement(Fragment, null,
            React.createElement(RowLR, { splitAt: splitAt },
                React.createElement(Pre, null, "Target week completion: "),
                React.createElement(Spinner, { min: 0, max: 1000, value: targetWeekCompletion, onChange: val => runInAction("GoalsSection.targetWeekCompletion.onChange", () => store.main.write.targetWeekCompletion = val.KeepBetween(0, 1000)) })),
            React.createElement(Row, null,
                React.createElement(Pre, null, "Show: "),
                React.createElement(CheckBox, { text: "Attributes", value: characters_showAttributes, onChange: val => runInAction("GoalsSection.targetWeekCompletion.onChange", () => store.main.write.characters_showAttributes = val) }),
                React.createElement(CheckBox, { ml: 5, text: "Description", value: characters_showDescription, onChange: val => runInAction("GoalsSection.targetWeekCompletion.onChange", () => store.main.write.characters_showDescription = val) })),
            React.createElement(Row, null,
                React.createElement(CheckBox, { text: "Screenshot mode", value: screenshotMode, onChange: val => runInAction("GoalsSection.targetWeekCompletion.onChange", () => store.main.write.screenshotMode = val) }))));
    }
};
GoalsSection = __decorate([
    Observer
], GoalsSection);
